export const borderRadius = {
  none: '0px',
  small: '4px',
  medium: '8px',
} as const;
